import { useCallback } from 'react'

import AudioEngine from '@/webgl/audio/AudioEngine'

export default function useAudioMusic() {
  const play = useCallback((id: string) => {
    AudioEngine.instance.music.play(id)
  }, [])

  const stop = useCallback(() => {
    AudioEngine.instance.music.stop()
  }, [])

  const setVolume = useCallback((volume: number, fade: number = 0) => {
    AudioEngine.instance.music.setVolume(volume, fade)
  }, [])

  return {
    play,
    stop,
    setVolume,
  }
}
